// extracted by mini-css-extract-plugin
module.exports = {"fixedIcon":"FixedIcon_fixedIcon__zuaC2"};